$(document).ready(function(){
        localStorage.setItem('set_html_mc', '');
  
        $(document.body).on('click', '.disclosure__item', function(e){
          var sig = $(this).find('.get-date-sig').attr('data-attr-sig');
          $( ".mobile_multicurrency .header_butn .country-selector__content" ).append( $( '<span class="country_currency_mobile">'+sig+'</span>' ) );
        });
        $(document.body).on('click', '.menuNav_trigger', function(e){
          var headtophtml = $('.country-selector-wrapper').html();
           var gethtml = localStorage.getItem("set_html_mc");
          if(gethtml == ''){
          	localStorage.setItem('set_html_mc', headtophtml);
          }
          var fetchhtml = localStorage.getItem("set_html_mc");
          $('.mobile_multicurrency').html(fetchhtml);
          $('.country-selector-wrapper').html('');
          
          var optval = localStorage.getItem('dac-locale-code');
          jQuery('.genrate_value select').val(optval).trigger('change');
        });
  
        $(document.body).on('click', '.mm-navbars_top', function(e){
          $('.header_butn').attr('aria-expanded', 'false');
          $(".disclosure__list").removeAttr('hidden');
        });
  
        $(".footer_butn").click(function(){
          $(this).find(".disclosure__list").slideToggle();
          $(this).attr('aria-expanded', 'true');
        });
        
        $(document.body).on('touchstart click', '.modal__country-footer button', function(e){
          var dataval = $(this).attr('data-value');
          localStorage.setItem('dac-locale-code', dataval);
          $('form#localization_form').submit();
         
        });
        
        $(document.body).on('click', '.modal__country-footer-2nd .disclosure__item', function(e){
          $('#mymodal__country').hide();
          var dataval =  $(this).closest('a').attr('data-value');
          localStorage.setItem('dac-locale-code', dataval);
          $('form#localization_form').submit();
        }); 
        
        $(document.body).on('click', '.mobile_multicurrency .disclosure__item', function(e){
          $('#my-menuNav').removeClass('mm-menu_opened');
          $('body').removeClass('mm-wrapper_opened');
          $('body').removeClass('mm-wrapper_blocking');
          $('body').removeClass('mm-wrapper_background');
          $('body').removeClass('mm-wrapper_opening');
          $('#my-menuNav').attr('aria-hidden', 'true')
        });
  
      var getcountry = localStorage.getItem("dac-user-country-check");
      if(getcountry){ } else {
        
        $.get("https://ipinfo.io/json", function (response) {
              var countryISO = response.country;
              if(countryISO){
                var target = '.disclosure__item[data-parent='+ countryISO +']';
                 setTimeout(function(){
                  $(target).find('a')[0].click();  
                  localStorage.setItem('dac-user-country-check', countryISO);                   
                 }, 1000);
              }
      },"jsonp");
      }
 });
      
document.addEventListener('DOMContentLoaded', function() {
  
    if (customElements.get('localization-form')) return;

    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
          button: this.querySelector('button'),
          panel: this.querySelector('ul'),
        };
        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        //this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
        this.elements.button.addEventListener('touchend', this.closeSelector.bind(this));
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

        this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        this.hidePanel();
        this.elements.button.focus();
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        //this.elements.input.value = event.currentTarget.dataset.value;
        //if (form) form.submit();
        const footSubmit = event.currentTarget.dataset.aap;
        const shouldSubmit = form && form.querySelector('[type="submit"]') == null && !event.currentTarget.dataset.ddp;
        const selectedValue = this.elements.button.querySelector('.country-selector__content');
        this.elements.input.value = event.currentTarget.dataset.value;
        selectedValue.innerHTML = event.currentTarget.querySelector('.country-selector__content').innerHTML;
        
        if(footSubmit){
          localStorage.setItem('dac-locale-code', event.currentTarget.dataset.value);
          form.submit();
          
        } else if (shouldSubmit || this.closest('.country-popup-selector')) {
          localStorage.setItem('dac-locale-code', event.currentTarget.dataset.value);
          var countryName = this.elements.button.querySelector('img').alt;
          var countrySrc = this.elements.button.querySelector('img').src;
          //form.submit();
          $("#myBtn").trigger('click');
          $(".disclosure__list").slideUp();
          $('.modal__country-h-name').text(countryName);
          $('.modal__country-img img').attr('src', countrySrc);
          $('.modal__country-img img').attr('alt', countryName);
          //$('.li-step-1').text('Welcome to '+ event.currentTarget.dataset.value);
          $('.li-step-1').text('Welcome to '+ countryName);
          //$('.li-step-2').text('Get shipping options for '+ countryName);
          $('.modal__country-footer button').attr('data-value', event.currentTarget.dataset.value);
          
        } else {
          //this.openWelcomePopup();
          form.submit();
        }
        //this.hidePanel();
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
      }

      closeSelector(event) {
        this.elements.button.blur();
        const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
        if (event.relatedTarget === null || shouldClose) {
          this.hidePanel();
        }
      }
    }

    customElements.define('localization-form', LocalizationForm);
});

  
        // Get the modal__country
        var modal__country = document.getElementById("mymodal__country");

        // Get the button that opens the modal__country
        var btn = document.getElementById("myBtn");

        // Get the <span> element that closes the modal__country
        var span = document.getElementById("close-cont");

        // When the user clicks the button, open the modal__country 
        btn.onclick = function() {
          modal__country.style.display = "block";
        }

        // When the user clicks on <span> (x), close the modal__country
        span.onclick = function() { 
          modal__country.style.display = "none";
          location.reload();
        }

        // When the user clicks anywhere outside of the modal__country, close it
        window.onclick = function(event) {
          if (event.target == modal__country) {
            //modal__country.style.display = "none";
          }
        }
	
        // Change shipping country
        var modal__country__pop = document.getElementById("mymodal__country__pop");
   
   		// Get the button that opens the modal__country
   		var btn__pop = document.getElementById("myBtn__pop");
   
  		 // Get the <span> element that closes the modal__country
        var span__pop = document.getElementById("close-cont__pop");
   
   		// When the user clicks the button, open the modal__country 
        btn__pop.onclick = function() {
          modal__country__pop.style.display = "block";
          modal__country.style.display = "none";
          
          var tophtml = $('.country-selector-wrapper').html();
          var tophtml_m = $('.mobile_multicurrency').html();
          if(tophtml !=''){
            $('.modal__country-footer-2nd').html(tophtml);
            $('.modal__country-footer-2nd #CountryList').removeAttr('style');
            $('.modal__country-footer-2nd #CountryList').attr('hidden', 'true');
          }else{
            $('.modal__country-footer-2nd').html(tophtml_m);
            $('.modal__country-footer-2nd #CountryList').removeAttr('style');
            $('.modal__country-footer-2nd #CountryList').attr('hidden', 'true');
          }
        }
        
        // When the user clicks on <span> (x), close the modal__country
        span__pop.onclick = function() { 
          modal__country__pop.style.display = "none";
          location.reload();
        }

